import React from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { gql, useMutation } from "@apollo/client";
import { toast } from "react-toastify";

const LOGIN_AZURE_AD_EMAIL = gql`
  mutation LoginAzureADEmail($code: String!) {
    loginAzureADEmail(code: $code) {
      token
    }
  }
`;

export const AzureADLoginMail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loginAzureADEmail] = useMutation<{ loginAzureADEmail: { token: string } }>(LOGIN_AZURE_AD_EMAIL);
  const [isLoading, setIsLoading] = React.useState(false);


  const handleAzureLogin = async (code:string) => {
    const {data} = await loginAzureADEmail({ variables: { code } })
    const token = data?.loginAzureADEmail?.token
    if (!token) {
      toast.error('Azure authentication failed');
      return;
    }
    
    // Set cookie for mail system
    setCookie('AuthorizationMailSystem', token);
    
    // Redirect to token-based message center
    navigate(`/messages/secure/${token}`);
  }

  // Cookie functions for mail system
  type StoredToken = { token: string; issued: number };
  const COOKIE_NAME = 'AuthorizationMailSystem';
  const MAX_AGE_MS = 12 * 60 * 60 * 1000; // 12 hours

  function setCookie(name: string, value: string) {
    const stored: StoredToken = { token: value, issued: Date.now() };
    const secureFlag = window.location.protocol === 'https:' ? ';Secure' : '';
    document.cookie =
      `${name}=${encodeURIComponent(JSON.stringify(stored))};path=/;SameSite=Strict${secureFlag}`;
  }


  React.useEffect(() => {
    const code = searchParams.get('code');    
    const error = searchParams.get('error');
    if (code) {          
      handleAzureLogin(code)
      return 
    } 
    
    if (error) {
      toast.error(error);
      setTimeout(() => {
        navigate("/login?error=sso_failed");
      }, 3000);
      return 
    }

  }, [searchParams, loginAzureADEmail, navigate]);


  return <></>

};

export default AzureADLoginMail; 
